import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import StationApi from "../../services/StationApi";
import DeviceApi from "../../services/DeviceApi";
import { useToast } from "../../context/ToastContext";

interface StationDialogProps {
    visible: boolean;
    onHide: () => void;
}

const TriggerDialog: React.FC<StationDialogProps> = ({ visible, onHide }): JSX.Element => {

    const [selectedStation, setSelectedStation] = useState();
    const [selectedDevice, setSelectedDevice] = useState();
    const [stations, setStations] = useState([]);
    const [devices, setDevices] = useState([]);
    const { displayToast } = useToast();

    useEffect(() => {
        fetchStations();
      }, []);

    const fetchStations = async (): Promise<void> => {
        const response = await StationApi.GetAllStations();
        const stationsMap = response.data.map((station: any) => ({
            value: station.id,
            label: station.name,
        }));
        setStations(stationsMap);
    };

    const fetchDevicesByStationId = async (stationId: number): Promise<void> => {
        const response = await DeviceApi.GetDevicesByStationId(stationId);
        const devicesMap = response.data.map((device: any) => ({
            value: device.id,
            label: device.name,
        }));
        setDevices(devicesMap);
    };

    const videoDeviceTrigger = async (): Promise<void> => {
        let response: any = null;

        try {
            response = await DeviceApi.VideoDeviceDetectionTrigger(selectedStation, selectedDevice);
            if (response.data || response.success) {
                displayToast("success", "Gatilho de detecção de vídeo executado com sucesso!", "", false, 3000);
            }
        } catch (e) {
            console.error('Failed: ', e);
            displayToast( "error", "Ocorreu um erro ao executar o gatilho", "", false, 3000 );
        }
    };

    return (
        <Dialog
            visible={visible}
            modal
            header={""}

            style={{ width: '50rem' }}
            onHide={onHide}
            breakpoints={{ '960px': '75vw', '641px': '100vw' }}
        >
            <div className="card flex flex-column gap-3">
                <div className="flex flex-column gap-2">
                    <label htmlFor="estacoes">Estações:</label>
                    <Dropdown
                        id="estacoes"
                        value={selectedStation}
                        options={stations}
                        onChange={(e: any) => {
                            fetchDevicesByStationId(e.target.value)
                            setSelectedStation(e.target.value)
                        }}
                    />
                </div>

                <div className="flex flex-column gap-2">
                    <label htmlFor="dispositivos">Dispositivos:</label>
                    <Dropdown
                        id="dispositivos"
                        value={selectedDevice}
                        options={devices}
                        onChange={(e) => setSelectedDevice(e.target.value)}
                    />
                </div>
            </div>

            <div className="flex justify-content-end">
                <Button
                    label="Enviar"
                    className={`${styles.submit} ${styles.toggleButton}`}
                    onClick={() => videoDeviceTrigger()}
                />
            </div>
        </Dialog>
    );
};

export default TriggerDialog;
